<template>
  <div>
    <div
      class="top"
    >
      <img
        src="../../img/qpxq/return.png"
        alt=""
        class="return"
        @click="gosy()"
      />
      <div class="bt">通知公告</div>
    </div>
    <div class="list-container">
      <div style="text-align: center; font-size: 5vw">{{info.bt}}</div>
      <div style="height: 2vw"></div>
      <div class="time">{{info.tjsj}}</div>
      <div style="height: 2vw"></div>
      <hr />
      <div style="height: 2vw" v-if="info.fmdz"></div>
      <img :src="imgUrl + info.fmdz" alt="" style="width: 100%" v-if="info.fmdz" />
      <div style="height: 2vw"></div>
      <div v-html="info.vt" class="noticeContent"></div>
    </div>
  </div>
</template>

<script>
import config from "../../../config/config.js";
import { Toast  } from "vant";
import { getTzggByPid } from "../../api/ZghApi/ZghAx";
export default {
  components: {},
  data() {
    return {
      imgUrl: config.fileShowUrl,
      pid: "",
      info:{}
    };
  },
  created() {
    this.pid = this.$route.params.pid;
    this.getTzggByPid();
  },
  methods: {
    getTzggByPid() {
      var params = { pid: this.pid };
      getTzggByPid(params).then((res) => {
        if (res.info!=null && Object.keys(res.info).length!=0) {
          this.info = res.info;
        } else {
          this.$toast("通知公告加载失败，请稍后重试！");
        }
      });
    },
    gosy() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
<style scoped>
.bt {
  position: absolute;
  left: 35vw;
  top: 4vw;
  width: 30vw;
  text-align: center;
  font-size: 4vw;
  font-weight: 600;
}
.noticeContent /deep/ img {
  max-width: 100% !important;
}
.list-container {
  padding: 14vw 3.6% 4.6%;
  min-height: 100%;
}
.time {
  font-size: 3vw;
  text-align: center;
  color: rgba(125, 125, 125, 1);
}
.listOut {
  margin-top: 2vw;
}
.imgOut {
  margin-bottom: 3vw;
}
.top {
  height: 12vw;
  width: 100vw;
  background-color: rgb(245, 247, 251);
  position: fixed;
}
.return {
  width: 5vw;
  margin-top: 1.8vw;
  margin-left: 4vw;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/tzggdetail.vue